import React from 'react';
import { useState } from 'react';
import IconButton from '../Buttons/IconButton/IconButton';
import { TString } from '../Response/Utils';
import styled from 'styled-components';

interface Props {
	showBot: Function;
	langCode: string;
	message: string;
	msgBackgroundColor: string;
	msgTextColor: string;
	showPrompt: boolean;
	closePrompt: Function;
	msgFontSize: string;
	colorScale: string[];
	selectedColor: string;
	colorMode: string;
}

const StyledComponent = styled.div`
	& .msg-section-wrapper {
		margin-bottom: 24px;
		margin-right: 24px;
	}
	& .msg-section-wrapper .tail-corner {
		display: -webkit-box;
		display: -webkit-flex;
		display: -ms-flexbox;
		display: flex;
		padding-right: 30px;
		-webkit-box-pack: end;
		-webkit-justify-content: flex-end;
		-ms-flex-pack: end;
		justify-content: flex-end;
	}
	& .msg-section-wrapper .tail-corner .arrow {
		height: 0;
		width: 0;
		border-top: 0px solid transparent;
		border-bottom: 10px solid transparent;
		border-left: 150px solid transparent;
		border-right: 12px solid
			${(props: any) => {
				return props.msgBackgroundColor;
			}};
	}
	& .msg-section-wrapper .msg-box-container {
		display: -webkit-box;
		display: -webkit-flex;
		display: -ms-flexbox;
		display: flex;
		-webkit-box-orient: vertical;
		-webkit-box-direction: normal;
		-webkit-flex-direction: column;
		-ms-flex-direction: column;
		flex-direction: column;
		-webkit-box-align: end;
		-webkit-align-items: end;
		-ms-flex-align: end;
		align-items: end;

		position: relative;
	}
	& .msg-section-wrapper .msg-box-container .msg-container {
		min-width: calc(96px - 40px) !important;
		max-width: calc(280px - 40px) !important;
		width: max-content;
		box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.28);
		background-color: ${(props: any) => {
			return props.msgBackgroundColor;
		}};
		color: ${(props: any) => {
			return props.msgTextColor;
		}};
		padding: 10px 18px;
		border-radius: 10px;
	}
	& .msg-section-wrapper .msg-box-container .msg-container:hover {
		box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.28);
	}
	& .msg-section-wrapper .msg-box-container::before {
		display: block;
		content: '';
		height: 0;
		width: 0;
		border: 13px solid transparent;
		border-top: 13px solid
			${(props) =>
				props.colorMode === 'dark'
					? props.selectedColor
					: props.colorScale && props.colorScale[4]};
		position: absolute;
		top: 100%;
		right: 20px;
		border-right: 10px;
	}
	& .msg-section-wrapper .msg-box-container::after {
		content: '';
		display: block;
		height: 0;
		width: 0;
		border: 12px solid transparent;
		border-top: 12px solid ${(props) => props.colorScale && props.colorScale[9]};
		position: absolute;
		top: 97%;
		right: 21px;
		border-right: 10px;
	}
	& .msg-section-wrapper .msg-box-container .msg-container .body-text-1 {
		overflow-wrap: break-word;
	}
	& .msg-section-wrapper .close-icon .icon-button {
		margin-right: 0px !important;
		height: 24px;
		width: 24px;
	}
	& .body-text-1 {
		font-size: ${(props: any) => {
			return props.msgFontSize;
		}};
	}
`;

const LauncherPrompt = (props: Props) => {
	return (
		<StyledComponent {...props}>
			<div
				className='msg-section-wrapper'
				style={
					props.showPrompt && props.message !== '' ? {} : { display: 'none' }
				}
			>
				{/* <div className='close-icon'>
					<IconButton
						size={'normal'}
						title={TString({
							labelName: 'closeLabel',
							langCode: props.langCode,
							fromClass: true,
						})}
						image={'close'}
						variant={'filled'}
						onClick={() => {
							props.closePrompt();
						}}
					/>
				</div> */}
				<div className='msg-box-container'>
					<div
						className='msg-container'
						onClick={() => {
							props.closePrompt();
							props.showBot();
						}}
						style={{
							backgroundColor: `${props.colorScale[9]}`,
							border: `1px solid ${props.selectedColor}`,
							color: `${props.colorScale[0]}`,
						}}
					>
						<span className='body-text-1'>{props.message}</span>
					</div>
					{/* <div className='tail-corner'>
						<div className='arrow'></div>
					</div> */}
				</div>
			</div>
		</StyledComponent>
	);
};

export default LauncherPrompt;
